// extracted by mini-css-extract-plugin
module.exports = {"footer":"foot_footer__17XNL","bar":"foot_bar__1oixL","footertxt":"foot_footertxt__Onwve"};